(function () {
    'use strict';

    angular
        .module('tfc.retailer.UIGrid')
        .controller('UIGridCtrl', UIGridCtrl)
        .constant('DirectionEnum', {
            'forward': 'forward',
            'backward': 'backward'
        });

    function UIGridCtrl($q, $scope, $timeout, DirectionEnum) {
        var firstPage = 0;
        var lastPage = 0;
        var nextPage = {};
        var storedGridData = {};
        var storedPageLength = -1;
        var newData = [];
        var lastIdentifier = {};

        var vm = this;
        vm.gridOptions = {
            enableSorting: false,
            infiniteScrollRowsFromEnd: vm.options.infiniteScrollRowsFromEnd,
            infiniteScrollUp: false,
            infiniteScrollDown: true,  // By default scroll will be down
            data: getFirstData(),
            onRegisterApi: function(gridApi){
                gridApi.infiniteScroll.on.needLoadMoreData($scope, getGridData.bind(null, DirectionEnum.forward));
                gridApi.infiniteScroll.on.needLoadMoreDataTop($scope, getGridData.bind(null, DirectionEnum.backward));
                vm.gridApi = gridApi;
            },
            columnDefs: vm.options.columnDefs
        };

        function getFirstData() {
            vm.getDataFn().then(function (data) {
                nextPage = data.nextPage;
                storedGridData[++storedPageLength] = data;
                var formatGridData = vm.getFormattedData({params:data.values});
                _.assign(lastIdentifier, vm.getLastIdentifier({data: formatGridData, index: formatGridData.length - 1}));
                vm.gridOptions.data = formatGridData;
            });
        }

        function getGridData(scrollDirection){
            return $q.when(getPageData(scrollDirection)).then(function(newDataResponse) {
                nextPage = newDataResponse.nextPage;
                newData = vm.getFormattedData({params:newDataResponse.values});
                _.assign(lastIdentifier, vm.getLastIdentifier({data: newData, index: newData.length - 1}));
                vm.gridApi.infiniteScroll.saveScrollPercentage();
                vm.gridOptions.data = (scrollDirection === DirectionEnum.forward) ? vm.gridOptions.data.concat(newData) : newData.concat(vm.gridOptions.data);
                return vm.gridApi.infiniteScroll.dataLoaded(firstPage > 0, nextPage != null).then(function () {
                    checkDataLength((scrollDirection === DirectionEnum.forward) ? DirectionEnum.backward : DirectionEnum.forward);
                });
            });
        }

        function getPageData(scrollDirection) {
            var page = (scrollDirection === DirectionEnum.forward) ? ++lastPage : --firstPage;
            //fetch from temp grid if data is available
            if (storedPageLength >= page) {
                return $q.when(storedGridData[page]);
            }
            else {
                return vm.getDataFn({lastIdentifier: lastIdentifier}).then(function (value) {
                    storedGridData[++storedPageLength] = value;
                    return value;
                }).catch(function (error) {
                    return vm.gridApi.infiniteScroll.dataLoaded();
                });
            }
        }

        function checkDataLength(discardDirection) {
            // work out whether we need to discard a page, if so discard from the direction passed in
            if( lastPage - firstPage > 1 ){
                // we want to remove a page
                vm.gridApi.infiniteScroll.saveScrollPercentage();
                if( discardDirection === DirectionEnum.backward ){
                    vm.gridOptions.data = vm.gridOptions.data.slice(vm.options.pageSize);
                    firstPage++;
                    $timeout(function() {
                        // wait for grid to ingest data changes
                        vm.gridApi.infiniteScroll.dataRemovedTop(firstPage > 0, nextPage != null);
                    });
                }else {
                    vm.gridOptions.data = vm.gridOptions.data.slice(0, vm.options.pageSize * 2);
                    lastPage--;
                    _.assign(lastIdentifier, vm.getLastIdentifier({data: newData, index: newData.length - 1}));
                    $timeout(function() {
                        // wait for grid to ingest data changes
                        vm.gridApi.infiniteScroll.dataRemovedBottom(firstPage > 0, nextPage != null);
                    });
                }
            }
        }
    }

}());

